module.exports = __webpack_public_path__ + "img/shipo-icon-order-top.1b3a32a6.svg";